import { z } from "zod";
export const fieldSettingsSchema = z.object({
    /** The label to display for the field */
    label: z.string().optional(),
    /**
     * If the field should be a text area instead of a text input. @deprecated use
     * isTextArea instead
     */
    textArea: z.boolean().optional(),
    /** If the field should be a text area instead of a text input. */
    isTextArea: z.boolean().optional(),
    /** If the field should be a file input instead of a text input. */
    isFileInput: z.boolean().optional(),
    /** If the field should be radio inputs instead of a select element. */
    isRadioList: z.boolean().optional(),
    /** If the field should be checkboxes instead of a select element. */
    isCheckBoxList: z.boolean().optional(),
    /**
     * The text to display as a placeholder in the field. If not set, it will be
     * blank.
     */
    placeholder: z.string().optional(),
    /**
     * The text to display as a description of the field. If not set, it will be
     * blank.
     */
    fieldDescription: z.string().optional(),
    /**
     * If the field should only be displayed if the specified other field is set
     * to a value.
     */
    dependsOn: z
        .union([
        z.string().optional(),
        z.object({
            field: z.string(),
            value: z.union([
                z.string(),
                z.array(z.union([z.string(), z.boolean(), z.number()])),
            ]),
        }),
    ])
        .optional(),
    /**
     * If the option should be considered as a false value if selected. (For the
     * purpose of dependsOn).
     */
    isNoOption: z.boolean().optional(),
    /** If the field should default to the first option in the list. */
    defaultToFirstOption: z.boolean().default(false),
    /** If the field should be hidden from the user entry form */
    hide: z.boolean().optional(),
});
/**
 * Get the custom field settings from the field description
 *
 * @param field The field to get the settings from
 * @returns The field settings or false if there are none
 */
export function getCustomFieldSettings(field) {
    let rawFieldSettings;
    try {
        rawFieldSettings = field.startsWith("{") ? JSON.parse(field) : false;
    }
    catch (_e) {
        return false;
    }
    if (!rawFieldSettings)
        return false;
    const fieldSettingsResult = fieldSettingsSchema.safeParse(rawFieldSettings);
    const fieldSettings = fieldSettingsResult.success
        ? fieldSettingsResult.data
        : false;
    return fieldSettings;
}
/**
 * Validate the custom field settings and return the stringified version.
 *
 * @param values The values to validate
 * @returns The stringified version of the values
 */
export function createCustomSettings(values) {
    return JSON.stringify(fieldSettingsSchema.parse(values));
}
//# sourceMappingURL=customSettings.js.map